import { MemberTableColumn } from 'router/subrouters/DataRoom/subrouters/Members/pages/Members/components/MembersFlatTable/data';

// The team table lives on its own page but shares the members table's query
// params namespace, so its sort, page and filters get their own keys.
export const TEAM_SORT_PARAM = 'teamSort';

export const TEAM_PAGE_PARAM = 'teamPage';

// The role column is left out on purpose: a member can hold several team
// roles, so an order over them means little — same as the members table.
export const TEAM_SORT_COLUMNS: MemberTableColumn[] = ['name', 'files', 'qa'];

// Filtering happens on the FE, so these params only ever drive the in-memory
// filtering in useTeamMemberFilters.
export const TEAM_FILTER_PARAMS = {
  NAME: 'teamName',
  FILES_ROLE: 'teamFilesRole',
  QA_ROLE: 'teamQaRole',
} as const;
